<template>
  <div ref="backgroundWrapper" class="about-us-background absolute locked w100">
    <div class="about-us-background__wrapper relative">
      <span ref="backgroundBubble1" class="about-us-background__bubble1 flex absolute"></span>
      <span ref="backgroundBubble2" class="about-us-background__bubble2 flex absolute"></span>
      <span ref="backgroundBubble3" class="about-us-background__bubble3 flex absolute"></span>
      <span ref="backgroundBubble4" class="about-us-background__bubble4 flex absolute"></span>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'AboutUsBackground',
  mounted() {
    this.parallaxListenerInit();
  },
  methods: {
    parallaxListenerInit() {
      if (!this.$refs.backgroundWrapper) return;

      // this.$refs.backgroundWrapper.addEventListener('mousemove', e => {
      //   if (
      //     !this.$refs.backgroundBubble1 ||
      //     !this.$refs.backgroundBubble2 ||
      //     !this.$refs.backgroundBubble3 ||
      //     !this.$refs.backgroundBubble4
      //   )
      //     return;
      //
      //   const pageX = e?.clientX - window.innerWidth / 2;
      //   const pageY = e?.clientY - window.innerHeight / 2;
      //
      //   this.$refs.backgroundBubble1.style.transform =
      //     'translateX(-' + (50 + pageX / 22) + '%) translateY(-' + (50 + pageY / 22) + '%)';
      //   this.$refs.backgroundBubble2.style.transform =
      //     'translateX(-' + (50 + pageX / 33) + '%) translateY(-' + (50 + pageY / 33) + '%)';
      //   this.$refs.backgroundBubble3.style.transform =
      //     'translateX(-' + (50 + pageX / 33) + '%) translateY(-' + (50 + pageY / 33) + '%)';
      //   this.$refs.backgroundBubble4.style.transform =
      //     'translateX(-' + (50 + pageX / 22) + '%) translateY(-' + (50 + pageY / 22) + '%)';
      // });
    },
  },
});
</script>

<style lang="scss" scoped>
.about-us-background {
  z-index: 1;
  height: 2187px;
  left: 0;
  top: -448px;

  &::before {
    content: '';
    position: absolute;
    opacity: 0.37;
    //width: 1316px;

    width: 100%;
    height: 1316px;
    top: -250px;
    background: radial-gradient(50% 50% at 50% 50%, rgba(198, 203, 237, 0.43) 0%, rgba(0, 38, 54, 0) 100%) no-repeat
      center center;
  }

  &__wrapper {
    width: 100%;
    max-width: var(--main-landing-page-container);
    margin: 0 auto;

    &::after,
    &::before {
      content: '';
      position: absolute;
    }

    &::after {
      width: 317px;
      height: 540px;
      right: -200px;
      top: 450px;
      background: radial-gradient(50% 50% at 50% 50%, #3e6e89 0%, rgba(22, 26, 33, 0) 100%);

      @include mq('md') {
        width: 1535px;
        height: 2088px;
        right: -1085px;
        top: -450px;
      }
    }

    &::before {
      width: 317px;
      height: 530px;
      left: -180px;
      top: 500px;
      background: radial-gradient(50% 50% at 50% 50%, #3d2343 0%, rgba(22, 26, 33, 0) 100%);

      @include mq('md') {
        width: 1535px;
        height: 2088px;
        left: -1038px;
        top: -355px;
      }
    }
  }

  &__bubble1,
  &__bubble2,
  &__bubble3,
  &__bubble4 {
    background: url('~@/components/partials/landings/about-us/images/bg/bubble.webp') no-repeat center center;
    background-size: contain;
    z-index: 1;
  }

  &__bubble1 {
    height: 23px;
    width: 23px;
    top: 540px;
    left: 20px;
    transform: rotate(-70deg);

    @include mq('lg') {
      height: 41px;
      width: 41px;
      top: 565px;
      left: 40px;
    }

    @include mq('xl') {
      left: 40px;
    }
  }

  &__bubble2 {
    height: 107px;
    width: 107px;
    top: 830px;
    left: -70px;

    @include mq('lg') {
      height: 126px;
      width: 126px;
      top: 920px;
      left: 20px;
    }

    @include mq('xl') {
      left: -200px;
    }
  }

  &__bubble3 {
    height: 75px;
    width: 75px;
    top: 550px;
    right: -50px;

    @include mq('lg') {
      height: 115px;
      width: 115px;
      top: 690px;
      right: 20px;
    }

    @include mq('xl') {
      right: -265px;
    }
  }

  &__bubble4 {
    background-image: url('~@/components/partials/landings/about-us/images/bg/bubble-blured.webp');
    height: 242px;
    width: 242px;
    top: 900px;
    right: -100px;

    @include mq('lg') {
      top: 1100px;
      right: 30px;
    }

    @include mq('xl') {
      right: -390px;
    }
  }
}
</style>
